import { Box, Button, ButtonGroup, Dialog, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'components/common/Link';
import React, { useState } from 'react';
import { colors } from 'styles/theme/colors';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { marketObjects } from 'constants/markets';
import useMarket from 'stores/useMarket';
import { FlagCircleOutlined } from '@mui/icons-material';
import MarketUrlHelper from 'helpers/MarketUrlHelper';

export default function CountryPicker() {
    const { t } = useServerTranslation();
    const [displayMarketOptions, setDisplayMarketOptions] = useState<boolean>(false);
    const [buttonsDisabled, setButtonsDisabled] = useState<boolean>(false);

    const theme = useTheme();
    const isWideScreen = !useMediaQuery(theme.breakpoints.down('md'));

    const market = useMarket();

    const marketClicked = (marketCode: string) => {
        setButtonsDisabled(true);
        changeMarket(marketCode);
    };

    const changeMarket = async (marketCode: string) => {
        const newMarket = marketObjects.find((m) => m.market === marketCode);

        if (!newMarket) {
            return;
        }

        const newUrl = await MarketUrlHelper.translateUrlForMarket(
            new URL(window.location.href),
            market.market,
            newMarket.market,
        );

        if (newUrl) {
            window.location.href = newUrl;
        }
    };

    const hideCountryOptions = () => {
        setButtonsDisabled(false);
        setDisplayMarketOptions(false);
    };

    const showCountryOptions = () => {
        setDisplayMarketOptions(true);
    };

    return (
        <>
            {displayMarketOptions
            && (
                <Box position="relative">
                    <Dialog
                        open={displayMarketOptions}
                        onClose={hideCountryOptions}
                    >
                        <ButtonGroup
                            orientation="vertical"
                            size="large"
                            aria-label="country options"
                            disabled={buttonsDisabled}
                        >
                            {marketObjects.map((m) => (
                                <Button
                                    disabled={m.market === market.market}
                                    style={{ padding: '24px 32px' }}
                                    variant="outlined"
                                    key={m.market}
                                    onClick={() => marketClicked(m.market)}
                                >
                                    {m.displayName}
                                </Button>
                            ))}
                        </ButtonGroup>
                        <Button
                            variant="contained"
                            sx={{
                                lineHeight: 1,
                                padding: '24px 32px',
                            }}
                            onClick={hideCountryOptions}
                            disabled={buttonsDisabled}
                        >
                            {t('my.cancel')}
                        </Button>
                    </Dialog>
                </Box>
            )}
            <Button
                variant="black"
                size="small"
                LinkComponent={Link}
                onClick={showCountryOptions}
                sx={{
                    borderRadius: { xs: '50%', md: '2px' },
                    padding: isWideScreen ? '0px 16px 0px 0px' : '0px 8px 0px 0px',
                    justifyContent: 'left',
                    '&:hover': { backgroundColor: { md: colors.white }, color: { md: colors.pink2 } },
                }}
            >
                {isWideScreen && (
                    <Box>
                        {t('footer.change-language')}
                    </Box>
                )}
                <FlagCircleOutlined sx={{ padding: '0px 0px 0px 4px' }} />
            </Button>
        </>
    );
}
